import styled from 'styled-components';

export const HelpSectionContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99999;
`;

export const HelpSectionMain = styled.div`
  width: 350px;
  height: 100vh;
  background: #ffffff;
  position: absolute;
  right: 0;
  top: 0;
`;

export const HelpSectionTopBar = styled.div`
  height: 36px;
  background: #4b286d;
`;

export const HelpSectionCloseButton = styled.div`
  background: none;
  border: 0;
  float: right;
  margin: 0.2rem 1rem;
  cursor: pointer;
  outline: 0;
`;

export const HelpBottomSection = styled.div`
  display: flex;
  flexdirection: column;
  padding: 2rem 4rem;
`;
